// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinkedinFilledSvg from "@fishx/icons-svg/es/asn/LinkedinFilled";
import FishxIcon from '../components/FishxIcon';

var LinkedinFilled = function LinkedinFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinFilledSvg
  }));
};

LinkedinFilled.displayName = 'LinkedinFilled';
export default React.forwardRef(LinkedinFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LinkedinFilled.js
// module id = 3047
// module chunks = 0